import React, {
  useState,
  useRef,
  useEffect,
  useContext,
  memo,
  useCallback,
} from "react";
import { Fade } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { cross_icn, Softorithm_White_Logo } from "../../images";
import sidebarContext from "../../context/sidebar/sidebarContext";
import { ThemeContext } from "../../context/theme/ThemeContext";
import AppSideBar from "../sidebar/AppSideBar";
import SmallScreen from "./smallscreen/SmallScreen";
import LargeScreen from "./largescreen/LargeScreen";
import {
  ButtonGroup,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

const AppHeader = memo(() => {
  const sidebarRref = useRef(null);
  const location = useLocation();

  const [searchtoggle, setsearchtoggle] = useState(false);
  const [sideMenu, setSideMenu] = useState(false);
  const [text, setText] = useState("ToolMenu");
  const [hamburger, setHamburger] = useState(false);
  const [toolState, setToolState] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  // to use sidebar using context
  const sidebarcontext = useContext(sidebarContext);
  /// de strusture
  const { setsidebarState } = sidebarcontext;
  const { themeColor, changeTheme } = useContext(ThemeContext);
  
  // Close sidebar when navigating to /tools
  useEffect(() => {
    if (location.pathname === "/tools") {
      // Close all sidebar states
      setSideMenu(false);
      setsidebarState(false);
      setHamburger(false);
      setToolState(false);
      setText("ToolMenu");
    }
  }, [location.pathname, setsidebarState]);
  
  // Also close sidebar immediately on mount if on /tools
  useEffect(() => {
    if (location.pathname === "/tools") {
      setSideMenu(false);
      setsidebarState(false);
      setHamburger(false);
      setToolState(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    // Theme is now handled by CSS variables in ThemeContext
    // No need for manual DOM manipulation here
  }, [themeColor]);

  const handleClickOutside = useCallback(
    (event) => {
      if (sidebarRref.current && !sidebarRref.current.contains(event.target)) {
        setSideMenu(false);
        setsidebarState(false);
        setHamburger(false);
      }
    },
    [sidebarRref, setSideMenu, setsidebarState]
  );

  const openSideNav = useCallback(
    (value) => {
      if (value === "ToolMenu") {
        setHamburger(false);
        setToolState(!toolState);
        setSideMenu(!toolState);
        setsidebarState(!toolState);
        setText(value);
      } else if (value === "pageMenu") {
        setToolState(false);
        setHamburger(!hamburger);
        setSideMenu(!hamburger);
        setsidebarState(!hamburger);
        setText(value);
      }
    },
    [
      hamburger,
      setHamburger,
      toolState,
      setToolState,
      setSideMenu,
      setsidebarState,
    ]
  );

  const closeSidebar = () => {
    setSideMenu(false);
    setsidebarState(false);
    setHamburger(false);
    setToolState(false);
  };

  const handleNavbarClick = (e) => {
    if (
      !e.target.classList.contains("ri-tools-line") &&
      !e.target.classList.contains("toggle_bar") &&
      !e.target.classList.contains("hamburger_icn")
    ) {
      closeSidebar();
    }
  };

  const itemClick = useCallback(
    (closeBar) => {
      if (sideMenu) {
        setSideMenu(closeBar);
        setsidebarState(closeBar);
        setHamburger(false);
        setToolState(false);
      }
    },
    [setsidebarState, sideMenu]
  );

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div className="AppHeader_Sidebar" ref={sidebarRref}>
        {/* <Fade
          className={searchtoggle ? "fadeIn " : "fadeOut "}
          in={searchtoggle}
          unmountOnExit={!searchtoggle}
        >
          <div
            className={`search_bx_overlay`}
            id="search_bx_overlay"
            style={{
              display: searchtoggle ? "block" : "",
              zIndex: searchtoggle ? "11" : "",
            }}
          >
            <span
              className="overlay_dismiss"
              onClick={() => {
                setsearchtoggle(false);
              }}
            >
              <img src={cross_icn} alt="Cross Icon"></img>
            </span>

            <div className="tp_search ">
              <input className="form-control" placeholder="Search"></input>

              <span className="search_icn">
                <i className="ri-search-line"></i>
              </span>
            </div>
          </div>
        </Fade> */}

        <div className="app_top_nav" onClick={handleNavbarClick}>
          <div className="app_logo">
            <Link to="/">
              <img src={Softorithm_White_Logo} alt="Logo"></img>
            </Link>
          </div>

          <div className="app_other_links">
            {/* <div className="tp_search">
              <input className="form-control" placeholder="Search"></input>
              <span className="search_icn">
                <i className="ri-search-line"></i>
              </span>
            </div> */}

            {/* Theme color dropdown */}
            <ButtonGroup>
              <UncontrolledDropdown
                isOpen={dropdownOpen}
                toggle={() => setDropdownOpen((prev) => !prev)}
                className="header-item topbar-user"
              >
                <DropdownToggle
                  tag="span"
                  className="text"
                  style={{
                    marginLeft: "1rem",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    gap: "0.5rem",
                  }}
                >
                  {/* Show icon for current theme */}
                  {themeColor === "#181818" ? (
                    <i className="ri-moon-fill" title="Dark Mode" />
                  ) : (
                    <i className="ri-sun-fill" title="Default/Light Mode" />
                  )}
                </DropdownToggle>
                <DropdownMenu className="border-0">
                  <DropdownItem
                    onClick={() => changeTheme("")}
                    style={{
                      color: "#212529",
                      display: "flex",
                      alignItems: "center",
                      gap: "0.5rem",
                    }}
                    active={themeColor === ""}
                  >
                    <i
                      className="ri-sun-fill"
                      style={{ color: themeColor === "" ? "#fff" : undefined }}
                    />{" "}
                    Default
                  </DropdownItem>
                  <DropdownItem
                    onClick={() => changeTheme("#181818")}
                    style={{
                      color: "#212529",
                      display: "flex",
                      alignItems: "center",
                      gap: "0.5rem",
                    }}
                    active={themeColor === "#181818"}
                  >
                    <i
                      className="ri-moon-fill"
                      style={{ color: themeColor === "#181818" ? "#fff" : undefined }}
                    />{" "}
                    Black
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            </ButtonGroup>

            <LargeScreen />
          </div>
          {/* Small Screen Size */}
          <SmallScreen
            setsearchtoggle={setsearchtoggle}
            setHamburger={setHamburger}
            hamburger={hamburger}
            setToolState={setToolState}
            toolState={toolState}
            openSideNav={openSideNav}
          />
        </div>

        <AppSideBar itemClick={itemClick} text={text} />
      </div>
    </>
  );
});

export default AppHeader;
